<wcg-dialog title="Contact Us">
  <div content>
    @if (data.isInternal) {
      <p>
        For WCG Workforce Support- please submit a ticket via email to
        <a href="mailto: helpdesk@wcgclinical.com">helpdesk&#64;wcgclinical.com</a
          >. We can assist with Okta, and other WCG Technology issues or
          requests. Please include as much detail about the submission, study, site,
          etc. to help in troubleshooting your issue.
        </p>
      }
      @if (data.isInternal) {
        <p>Information below is for Client Support ONLY.</p>
      }

      <p>Need to get in contact with WCG?</p>
      <p>Phone: <a href="tel:+18558182289">1-855-818-2289</a></p>
      <p>
        Email:
        <a href="mailto: ClientCare@wcgclinical.com"
          >ClientCare&#64;wcgclinical.com</a
          >
        </p>
        <p>
          <span class="title">Hours of Operation:</span> 8:00 AM to 8:00 PM Eastern
          Time
        </p>
        <p>
          <span class="title">Days of Operation: </span
            ><span>Monday to Friday</span>
          </p>
        </div>

        <div primary>
          <button
            mat-flat-button
            mat-button
            wcg-button
            color="primary"
            data-testid="contact-us-don"
            (click)="handleDone()"
            >
            Done
          </button>
        </div>
      </wcg-dialog>
